import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'database-placeholder',
  templateUrl: './database-placeholder.component.html',
  styleUrls: ['./database-placeholder.component.scss']
})
export class DatabasePlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
